export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_00.fad79690.jpg";